const serviceImages = {
  residential: require('./Realestate/residential.png'),
  specialized:require('./Realestate/specialized.jpeg'),
  CommercialCleanings:require('./Realestate/CommercialCleanings.jpeg'),
  PropertyManagement:require('./Realestate/PropertyManagement.jpeg'),
  RealEstateAppraisal:require('./Realestate/RealEstateAppraisal.jpeg'),
  RealEstateDevelopment:require('./Realestate/RealEstateDevelopment.jpeg'),
  digital:require('./Realestate/digital.jpeg'),
  support :require('./Realestate/support.jpeg'),
  land : require('./Realestate/land.jpeg'),
  commercial :require('./Realestate/commercial.jpeg'),
  carcare: require('./Car/carcare.jpeg'),
  customization :require('./Car/customization.jpeg'),
  partsaccessories:require('./Car/partsaccessories.jpeg'),
  rentalleasing:require('./Car/rentalleasing.png'),
  supportservices:require('./Car/supportservices.jpeg'),
  roadsideassistance:require('./Car/roadsideassistance.webp'),
  EventPhotography:require('./Photography/EventPhotography.jpeg'),
  ProductPhotography:require('./Photography/ProductPhotography.jpeg'),
  ModelShoots:require('./Photography/ModelShoots.jpeg'),
  CorporateHeadshots:require('./Photography/EventPhotography.jpeg'),
  RealEstatePhotography:require('./Photography/RealEstatePhotography.jpeg'),
  ProfessionalPhotos:require('./Photography/ProfessionalPhotos.jpeg'),
  BrandLifestyle:require('./Photography/BrandLifestyle.jpeg'),
  barber: require('./Beauty/barber.jpeg'), 
  salon: require('./Beauty/salon.jpeg'),  
  spa: require('./Beauty/spa.jpeg'),
  cosmetic: require('./Beauty/cosmetic.jpeg'),
  courier:require('./Transport & Shipping/courier.jpg'),
  corepayrollprocessing:require('./payroll/corepayrollprocessing.jpeg'),
  compliancereporting:require('./payroll/compliancereporting.jpeg'),
  advancedpayroll:require('./payroll/advancedpayroll.jpeg'),
  transportother:require('./Transport & Shipping/transportother.jpg'),
  HomeStaging:require('./Interior/HomeStaging.png'),
  CommercialDesign:require('./Interior/CommercialDesign.jpeg'),
    ResidentialDesign: require('./Interior/ResidentialDesign.png'),
  Baker:require('./Food/Baker.jpeg'),
  BeverageService: require('./Food/BeverageService.jpeg'),
  Caterer:require('./Food/Caterer.jpeg'),
  Chocolatier:require('./Food/Chocolatier.jpeg'),
  FoodService:require('./Food/FoodService.jpeg'),
  FoodBeverage:require('./Food/FoodBeverage.jpeg'),
  AccountingServices:require('./Legal Accounting/AccountingServices.jpeg'),
  Auditors:require('./Legal Accounting/Auditors.jpeg'),
  LawServices:require('./Legal Accounting/LawServices.jpeg'),
  IPLaw:require('./Legal Accounting/IPLaw.jpeg'),
  PayrollServices:require('./Legal Accounting/PayrollServices.jpeg'),
  AlternativeWellness:require('./Health/AlternativeWellness.png'),
  CounselorPsychotherapist:require('./Health/CounselorPsychotherapist.png'),
  Dentist:require('./Health/Dentist.png'),
  businesstraining:require('./Training Coaching/business-training.jpg'),
  educationalfacilities:require('./Training Coaching/educational-facilities.jpg'),
  educationalservice:require('./Training Coaching/educational-service.jpg'),
  languageteaching:require('./Training Coaching/language-teaching.jpg'),
  leadershipcoach:require('./Training Coaching/leadership-coach.jpg'),
  lifecoach:require('./Training Coaching/life-coach.jpg'),
  mindcoach:require('./Training Coaching/mind-coach.jpg'),
  othertraining:require('./Training Coaching/other-training.jpg'),
  mobiletelecom:require('./Telecommunications/mobile-telecom.jpg'),
  telecomother:require('./Telecommunications/telecom-other.jpg'),
  telecomproducts:require('./Telecommunications/telecom-products.jpg'),
  SEOServices:require('./Digital/SEOServices.png'),
  SocialMediaManagement:require('./Digital/SocialMediaManagement.png'),
  PerformanceMarketing: require('./Digital/Performance Marketing.jpeg'),
  corporatelaw:require('./law/corporatelaw.jpeg'),
  familylaw:require('./law/familylaw.jpeg'),
  employmentcontracts:require('./law/employmentcontracts.jpeg'),
  workplaceregulations:require('./law/workplaceregulations.jpeg'),
  disputeresolution:require('./law/disputeresolution.jpeg'),
  generalpestcontrol:require('./Pest Control/generalpestcontrol.jpg'),
  termitecontrol:require('./Pest Control/termitecontrol.jpg'),
  bedbugscontrol:require('./Pest Control/bedbugscontrol.jpg'),
  ticketing:require('./Travel/ticketing.jpg'),
  othertravel:require('./Travel/othertravel.jpg'),
  CCTV:require('./Security & Investigation/CCTV.jpg'),
  FireProtection:require('./Security & Investigation/FireProtection.jpg'),
  Securityother:require('./Security & Investigation/Securityother.jpg'),
  SecurityPersonnel:require('./Security & Investigation/SecurityPersonnel.jpg'),
  flexiblepackaging:require('./pack/flexiblepackaging.jpeg'),
  rigidpackaging:require('./pack/rigidpackaging.jpeg'),
  ecopolymersolutions:require('./pack/ecopolymersolutions.jpeg'),
  broilerchickensupply:require('./Poultry/broilerchickensupply.jpg'),
  eggsupplyanddistribution:require('./Poultry/eggsupplyanddistribution.jpg'),
  poultryfarmsupplies:require('./Poultry/poultryfarmsupplies.jpg'),
  Astrologist:require('./Personal Services/Astrologist.jpg'),
  ColorStyleConsultant:require('./Personal Services/ColorStyleConsultant.jpg'),
  CosmeticsSkinCare:require('./Personal Services/CosmeticsSkinCare.jpg'),
  DryCleaningLaundry:require('./Personal Services/DryCleaningLaundry.jpg'),
  FuneralPlanningServices:require('./Personal Services/FuneralPlanningServices.jpg'),
  HairStylist:require('./Personal Services/HairStylist.jpg'),
  SalonSpa:require('./Personal Services/SalonSpa.jpg'),
  WeddingPlanner:require('./Personal Services/WeddingPlanner.jpg'),
  OrganizationsOtherOther:require('./Organizations & Others/OrganizationsOtherOther.jpg'),
  NonProfitsFundraisingOrganizations:require('./Organizations & Others/NonProfitsFundraisingOrganizations.jpg'),
  toursguide:require('./Travel/toursguide.jpg'),
  travelagents:require('./Travel/travelagents.jpg'),
  WebDevelopment:require('./Digital/WebDevelopment.jpeg'),
  ContentMarketing: require('./Digital/Content Marketing.jpeg'),
  Apparel:require('./Manufacturing/Apparel.jpg'),
  ChemicalProducts:require('./Manufacturing/Chemical Products.jpg'),
  ComputerElectronicsOptical:require('./Manufacturing/ComputerElectronicsOptical.jpg'),
  ElectricalEquipment:require('./Manufacturing/ElectricalEquipment.jpg'),
  FoodProducts:require('./Manufacturing/FoodProducts.jpg'),
  internationalrelocation:require('./Moving/internationalrelocation.jpg'),
  localmoving:require('./Moving/localmoving.jpg'),
  petsitting:require('./pets/petsitting.jpeg'),
  petgrooming:require('./pets/petgrooming.jpeg'),
  telemedicine:require('./Healthcare/telemedicine.jpeg'),
  home_nursing:require('./Healthcare/home_nursing.jpeg'),
  dental_services:require('./Healthcare/dental_services.jpeg'),
  specialized_clinics:require('./Healthcare/specialized_clinics.jpeg'),
  diagnostic_services:require('./Healthcare/diagnostic_services.jpeg'),
  men_wellness:require('./Healthcare/men_wellness.jpeg'),
  mental_health:require('./Healthcare/mental_health.jpeg'),
  adAgency: require('./adAgency.png'),
  salespurchase :require('./Car/salespurchase.jpeg'),
  maintenance :require('./Car/maintenance.png'),
  loanservices:require('./Loan/loanservices.jpeg'),
  transportation:require('./Logistics/transportation.jpeg'),
  inventorytech:require('./Logistics/inventorytech.jpeg'),
  workforcesupply:require('./Manpower/workforcesupply.jpeg'),
  kitchenremodeling:require('./Kitchen/kitchenremodeling.jpeg'),
  homemaintenance:require('./Maintenance/homemaintenance.png'),
  industrialmaintenance:require('./Maintenance/industrialmaintenance.png'),
  notarization:require('./law/notarization.png'),
  documenttranslation:require('./law/documenttranslation.png'),
  virtualassistance:require('./Office Support/virtualassistance.png'),
  itsupport:require('./Office Support/itsupport.png'),
  cookingappliances:require('./Kitchen/cookingappliances.jpeg'),
  watercoolingappliances:require('./Kitchen/watercoolingappliances.jpeg'),  
  appliancerepair:require('./Kitchen/appliancerepair.jpeg'),
  ResidentialCleaning: require('./Cleaning/residentialcleaning.png'),
  CommercialCleaning: require('./Cleaning/commercialcleaning.png'),
  SpecialtyCleaning: require('./Cleaning/SpecialtyCleaning.png'),  
  AnalyticsReporting: require('./Digital/Analytics & Reporting.jpeg'), 
  brandcollateral: require('./brand/collateral.jpg'),
  branddigital: require('./brand/digital.jpg'), 
  brandexperience: require('./brand/experience.jpg'),
  brandidentity: require('./brand/identity.jpg'),
  brandstrategy: require('./brand/strategy.jpg'),
  ComputingDevices: require('./Home Appliance Repair/Computing Devices.jpg'),
  container_gardening: require('./Gardening Services/container_gardening.jpg'),
  TileMasonry:require('./Home Repair Maintenance/TileMasonry.jpg'),
  ElectricalServices:require('./Home Repair Maintenance/Electrical Services.jpg'),
  PaintingServices:require('./Home Repair Maintenance/Painting Services.jpg'),
  PlumbingServices:require('./Home Repair Maintenance/Plumbing Services.jpg'),
  jewelrycleaning:require('./Repair/jewelrycleaning.jpeg'),
  watchservicing:require('./Repair/watchservicing.jpeg'),
  LargeFormatPrinting:require('./Printing/LargeFormatPrinting.jpeg'),
  ScreenPrinting:require('./Printing/ScreenPrinting.jpeg'),
  OffsetPrinting:require('./Printing/OffsetPrinting.jpeg'),
  DigitalPrinting:require('./Printing/DigitalPrinting.jpeg'),
  VehicleWraps:require('./Printing/VehicleWraps.jpeg'),
  CoolingAppliances: require('./Cooling Appliances.jpg'),
  specialtypainting:require('./Paint/specialtypainting.jpeg'),
  Commercialpainting:require('./Paint/CommercialPainting.jpeg'),
  residentialpainting:require('./Paint/residentialpainting.jpeg'),
  corporate: require('./Event/corporate.jpg'),
  personal_events: require('./Event/personal_events.jpg'),
  electrical: require('./Event/electrical.jpg'),
  partydecor: require('./Event/partydecor.jpg'),
  CallCenterAnsweringService:require('./Event/CallCenterAnsweringService.jpg'),
  CorporateEvents:require('./Event/CorporateEvents.jpg'),
  EventManagerMarketer:require('./Event/EventManagerMarketer.jpg'),
  EventPlanner:require('./Event/EventPlanner.jpg'),
  personalevents :require('./personal_events.png'),
   wedding: require('./Event/wedding.jpg'),
  makeupstyling :require('./Event/makeup_styling.jpg'),
  mediaservices :require('./Event/mediaservices.jpg'),
  personaltraining :require('./personaltraining.png'),
  corporate_wellness :require('./corporate_wellness.png'),
  gym_management :require('./gymmanagement.png'),
  EntertainmentDevice: require('./Entertainment Device.jpg'),
  flower_gardening: require('./Gardening Services/flower_gardening.jpg'),
  vegetable_gardening: require('./Gardening Services/vegetable_gardening.jpg'),
  water_gardening: require('./Gardening Services/water_gardening.jpg'),
  herb_gardening: require('./Gardening Services/herb_gardening.jpg'),
  HomeAutomation: require('./Home Automation.jpg'),
  IndustrialAutomation: require('./Industrial Manufacturing/Industrial Automation.jpg'),
  RareEquipmentMaintenance: require('./Industrial Manufacturing/Rare Equipment Maintenance.jpg'),
  HomeAutomation:require('./Home Appliance Repair/Home Automation.jpg'),
  LaundryAppliances:require('./Home Appliance Repair/Laundry Appliances.jpg'),
  WaterHeatingAppliances:require('./Home Appliance Repair/Water Heating Appliances.jpg'),
  EntertainmentDevices:require('./Home Appliance Repair/Entertainment Devices.jpg'),
  CoolingAppliances:require('./Home Appliance Repair/Cooling Appliances.jpg'),
  Industry40Integration: require('./Industrial Manufacturing/Industry 4.0 Integration.jpg'),
  sportsleisureother:require('./Sports  Leisure/sports-leisure-other.jpg'),
  yogapilates:require('./Sports  Leisure/yoga-pilates.jpg'),
  Insurance: require('./Finance & Insurance/insurance.jpg'),
  AssetFinance:require('./Finance & Insurance/AssetFinance.jpg'),
  BankingServices:require('./Finance & Insurance/BankingServices.jpg'),
  BusinessFinancing:require('./Finance & Insurance/BusinessFinancing.jpg'),
  landscape_design: require('./Gardening & Landscaping/landscape_design.jpg'),
  LaundryAppliances: require('./Home Appliance Repair/Laundry Appliances.jpg'),
  CarpentryServices:require('./Home Repair Maintenance/Carpentry Services.jpg'),
  lawn_care: require('./Gardening & Landscaping/lawn_care.jpg'),
  power_tools: require('./Gardening & Landscaping/power_tools.jpg'),
  tree_services: require('./Gardening & Landscaping/tree_services.jpg'),
  WaterHeatingAppliances: require('./Home Appliance Repair/Water Heating Appliances.jpg'),
  CopywritingServices: require('./CopywriterWriter/Copywriting Services.png'),
  default: require('./default.png'),
};

export default serviceImages;
